import api from './axios';
import { Client, CreateClientDto, UpdateClientDto } from '../types/client';
import { buildQueryString } from '../lib/pagination';

interface GetClientsParams {
  search?: string;
  page?: number;
  limit?: number;
}

export const clientsApi = {
  getAll: async (params?: GetClientsParams) => {
    const query = buildQueryString({
      search: params?.search,
      page: params?.page,
      limit: params?.limit,
    });

    const response = await api.get(`/clients${query}`);
    return response.data;
  },
  getById: (id: number) => api.get<{ data: Client }>(`/clients/${id}`).then(res => res.data.data),
  search: (query: string) => api.get<{ data: Client[] }>(`/clients/buscar?q=${query}`).then(res => res.data.data),
  create: (data: CreateClientDto) => api.post<{ data: Client }>('/clients', data).then(res => res.data.data),
  update: (id: number, data: UpdateClientDto) => api.put<{ data: Client }>(`/clients/${id}`, data).then(res => res.data.data),
  delete: (id: number) => api.delete(`/clients/${id}`),
};

export const exportarClientesPDF = async (search?: string): Promise<string> => {
  try {
    const params = search && search.trim() ? { search: search.trim() } : {};
    const response = await api.get('/clients/exportar-pdf', { params });

    console.log('Respuesta del servidor:', response.data);

    if (response.data.success && response.data.data?.url) {
      let url = response.data.data.url;

      if (url.startsWith('/') || url.startsWith('./')) {
        const baseApiUrl = import.meta.env.VITE_API_URL || '';
        const backendDomain = baseApiUrl.replace(/\/api$/, '') || window.location.origin;

        if (url.startsWith('./')) {
          url = url.substring(1);
        }

        const cleanUrl = url.startsWith('/') ? url : `/${url}`;
        url = `${backendDomain}${cleanUrl}`;
      }

      console.log('URL final del PDF:', url);
      return url;
    }

    throw new Error('La respuesta no contiene una URL válida');
  } catch (error) {
    console.error('Error exportando PDF:', error);
    throw error;
  }
};

export default api;